import type React from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { Box, Skeleton, Typography } from '@mui/material';

import { PAGE_TYPES } from 'src/constants/module';
import useSimpleContentPage from 'src/hooks/useSimpleContentPage';
import { routePaths } from 'src/services/routing/routePaths';
import useUserPermissions from 'src/components/app/context/UserContext/useUserPermissions';

const DataProtectionModalContent: React.FC = () => {
  const { activeUserPermissionsInCurrentSurvey } = useUserPermissions();
  const { t } = useTranslation('common');
  const isUserOfAnyModule = activeUserPermissionsInCurrentSurvey.length > 0;
  const { pageContent, error, loading } = useSimpleContentPage(
    PAGE_TYPES.DATA_PROTECTION,
  );

  return (
    <Box sx={{ px: 4 }}>
      <Box sx={{ my: 2, lineHeight: '1.5rem' }}>
        {loading ? (
          <Skeleton variant="text" height={30} />
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <Markdown>{pageContent}</Markdown>
        )}
      </Box>
      {isUserOfAnyModule && (
        <Box sx={{ my: 2, lineHeight: '1.5rem' }}>
          <Link
            to={routePaths.TERMS_OF_USAGE}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer.ReadTermsOfUsage')}
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default DataProtectionModalContent;
